module.exports = __webpack_public_path__ + "static/review-2725508359824936dde3dcc76336b9ca.webp";